import { useEffect, useState } from 'react';
import { Routes, Route, NavLink } from 'react-router';

import Promo from '../promo/Promo';
import Newlyweds from '../newlyweds/Newlyweds';
import Maps from '../maps/Maps';
import Ruls from '../rules/Rules';
import Table from '../table/Tabel';
import Snowfall from 'react-snowfall'

function App() {
  const targetDate = new Date('2026-01-16T12:00:00');

  const calculateTimeLeft = () => { 
    const now = new Date(); 
    const diff = targetDate - now; 
    if (diff <= 0) return null;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => { 
    const id = setInterval(() => { setTimeLeft(calculateTimeLeft()); }, 1000); 
    return () => clearInterval(id); 
  }, []);

  return (
    <div className="App">
        <Snowfall snowflakeCount={200} style={{ zIndex: 99, position: 'fixed', width: '100vw', height: '100vh', }}/>
      <Promo timer={timeLeft} />
      <Routes>
        <Route path='/' element={<Newlyweds />} />
        <Route path='*' element={<Newlyweds />} />
      </Routes>
      <Maps />
      <Table />
      <Ruls />
    </div>
  );
}

export default App;
